import React from 'react';
import { classDetailsFields } from './classDetailsFields';

const ClassDetails = ({ singleClass }) => {
  const fields = classDetailsFields(singleClass.__t, singleClass);

  return (
    <div>
      {fields.map((elem, index) => (
        <div key={index}>
          {elem.label}: {elem.value}
        </div>
      ))}
    </div>
  );
};

export default ClassDetails;
